import {ordersServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = ordersServicesPath + '/organizations/job-workers'

export default class JobWorkersService {

    static async getAllWithFilter(pageNumber, pageSize, workerId, startCompletion, startShipped, startPaid, finishCompletion, finishShipped, finishPaid) {
        const params = {
            page: pageNumber,
            pageSize: pageSize,
            workerId: workerId,
            startCompletion: startCompletion,
            startShipped: startShipped,
            startPaid: startPaid,
            finishCompletion: finishCompletion,
            finishShipped: finishShipped,
            finishPaid: finishPaid
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        return axios.get(`${restUrl}/salary?${queryString}`)
    }

    static async getReportRemains(workerId, date) {
        const params = {
            workerId: workerId,
            date: date,
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        return axios.get(`${restUrl}/report-remains?${queryString}`)
    }

    static async getReport(startCompletion, startShipped, startPaid, finishCompletion, finishShipped, finishPaid) {
        const params = {
            startCompletion: startCompletion,
            startShipped: startShipped,
            startPaid: startPaid,
            finishCompletion: finishCompletion,
            finishShipped: finishShipped,
            finishPaid: finishPaid
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        return axios.get(`${restUrl}/report?${queryString}`)
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id);
    }

    static async paidBetween(startShipped, finishShipped) {
        return axios.patch(`${restUrl}/paid-between?startShipped=${startShipped}&finishShipped=${finishShipped}`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async paidIds(data) {
        return axios.patch(`${restUrl}/paid-ids`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

}
